import React from 'react'
import Layout from './layout'
import unsubscribeData from '../components/content/signup/unsubscribe.en-XC.yaml'

export default function Unsubscribe() {
  return (
    <Layout>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 unsubscribed-toggle">
          <h1>{unsubscribeData.content.unsubscribe_message}</h1>
        </div>
      </div>
    </Layout>
  )
}
